import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import Seo from "@/components/Seo";
import { Loader2, ArrowLeft } from "lucide-react";

export default function BlogDetail() {
  const { slug } = useParams();
  const { lang } = useI18n();
  const [post, setPost] = useState(null);
  const [nf, setNf] = useState(false);

  useEffect(() => { api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setNf(true)); }, [slug]);

  if (nf) return <div className="section-lux container-lux text-center"><h1 className="text-3xl font-bold text-white">Article not found</h1><Link to="/blog" className="gold-btn mt-6 inline-flex">Back to Blog</Link></div>;
  if (!post) return <div className="flex justify-center py-40"><Loader2 className="animate-spin text-amber-400" size={40} /></div>;

  const title = lang === "id" && post.title_id ? post.title_id : post.title;
  const content = lang === "id" && post.content_id ? post.content_id : post.content;

  return (
    <article className="section-lux">
      <Seo title={post.seo_title || title} description={post.seo_description || post.excerpt} image={post.featured_image || undefined}
        schema={{ "@context": "https://schema.org", "@type": "Article", headline: title,
          image: post.featured_image || undefined, datePublished: post.created_at,
          author: { "@type": "Organization", name: post.author || "ADNEXA DIGITAL" },
          publisher: { "@type": "Organization", name: "ADNEXA DIGITAL" } }} />
      <div className="container-lux max-w-3xl">
        <Link to="/blog" className="inline-flex items-center gap-2 text-sm text-amber-400 mb-6"><ArrowLeft size={15} /> Back to Blog</Link>
        <div className="label-lux mb-3">{post.category}</div>
        <h1 className="text-3xl sm:text-4xl font-extrabold text-white leading-tight">{title}</h1>
        <div className="text-sm text-slate-500 mt-3">{post.author} · {(post.created_at || "").slice(0, 10)}</div>
        {post.featured_image && <img src={post.featured_image} alt={title} className="w-full h-72 object-cover rounded-2xl mt-8 border border-amber-500/15" />}
        <div className="prose prose-invert max-w-none mt-8 text-slate-300 leading-relaxed [&_p]:mb-4 [&_a]:text-amber-400" dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    </article>
  );
}
